import * as React from 'react'
import { SVGProps } from 'react'
const SvgPin3 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={12} height={14} viewBox="0 0 12 14" fill="none" {...props}>
    <path
      d="M6.001 6.897c.363 0 .673-.13.93-.391.258-.261.386-.575.386-.941 0-.367-.129-.68-.387-.94a1.265 1.265 0 0 0-.931-.39c-.363 0-.673.13-.93.391a1.292 1.292 0 0 0-.386.941c0 .367.129.68.387.94.258.26.569.39.931.39ZM6 12.53c1.426-1.29 2.516-2.527 3.273-3.711.756-1.185 1.134-2.222 1.134-3.113 0-1.342-.422-2.446-1.266-3.311C8.297 1.53 7.25 1.098 6 1.098s-2.297.432-3.14 1.297c-.845.865-1.267 1.969-1.267 3.311 0 .89.378 1.928 1.134 3.113C3.484 10.003 4.574 11.24 6 12.53ZM6 14c-1.834-1.606-3.209-3.1-4.125-4.484C.958 8.133.5 6.863.5 5.706c0-1.7.544-3.075 1.632-4.128C3.22.526 4.509 0 6 0s2.78.526 3.868 1.578C10.956 2.631 11.5 4.007 11.5 5.706c0 1.157-.458 2.427-1.375 3.81C9.21 10.9 7.834 12.394 6 14Z"
      fill="#000"
    />
  </svg>
)
export default SvgPin3
